import React from 'react';

import {
    useMediaConfig,
    useDictionary,
    useLang,
} from 'bdvp-common/src/hooks/config';
import { useAdobeTarget, useSuggestedSearches } from 'bdvp-common/src/hooks/store';

import Component from '../components/SearchInput';

const SearchInput = (props) => {

    let {
        placeholder_text: placeholder = 'Search (ex. Ohtani home runs in the 9th inning)',
    } = useDictionary();
    const { adobeTarget: adobeTargetConfig = {}, suggestedSearchesTotal = 6 } = useMediaConfig();

    const lang = useLang();
    const {
        loading: ftsPlaceholderLoading,
        payload: ftsPlaceholderPayload = {},
        enabled: ftsPlaceholderEnabled,
    } = useAdobeTarget(adobeTargetConfig, 'ftsPlaceholder');
    const { data: suggestedSearches } = useSuggestedSearches(suggestedSearchesTotal);

    if (ftsPlaceholderEnabled && !ftsPlaceholderLoading) {

        placeholder = ftsPlaceholderPayload[lang] ?? placeholder;

    }

    return <Component {...props} placeholder={placeholder} suggestedSearches={suggestedSearches} />;

};

export default SearchInput;
